/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { ActionAudDtoToJSON, ActionAudFilterDtoToJSON, ActionAudPagedDtoFromJSON, } from '../models/index';
/**
 *
 */
export class ControllerDedicatoAFunzioniSoloPerAuditApi extends runtime.BaseAPI {
    /**
     * tiene traccia delle azioni svolte dall\'utente.
     * tiene traccia delle azioni svolte dall\'utente
     */
    insertActionAudRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['actionAudDto'] == null) {
                throw new runtime.RequiredError('actionAudDto', 'Required parameter "actionAudDto" was null or undefined when calling insertActionAud().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/action/create`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ActionAudDtoToJSON(requestParameters['actionAudDto']),
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * tiene traccia delle azioni svolte dall\'utente.
     * tiene traccia delle azioni svolte dall\'utente
     */
    insertActionAud(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.insertActionAudRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Ricerca azioni utente
     * Ricerca azioni utente
     */
    searchActionAudRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['actionAudFilterDto'] == null) {
                throw new runtime.RequiredError('actionAudFilterDto', 'Required parameter "actionAudFilterDto" was null or undefined when calling searchActionAud().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/action/search`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ActionAudFilterDtoToJSON(requestParameters['actionAudFilterDto']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ActionAudPagedDtoFromJSON(jsonValue));
        });
    }
    /**
     * Ricerca azioni utente
     * Ricerca azioni utente
     */
    searchActionAud(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.searchActionAudRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
